import { render, staticRenderFns } from "./SyncStatus.vue?vue&type=template&id=10b5c499&lang=pug&"
import script from "./SyncStatus.vue?vue&type=script&lang=js&"
export * from "./SyncStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports